import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class LoginController extends Controller {
  @tracked username: string = '';
  @tracked password: string = '';
  @service declare router: RouterService;

  @action
  login() {
    localStorage.setItem('session', 'true');
    this.router.transitionTo('auth.smartphone');
  }
}
